
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Section from "./Section";
import { useJobContext } from "../../context/JobContext";
import Navbars from "../../Layout/Navbar";

const DetailJob = () => {
  const { jobName } = useParams<{ jobName: string }>();
  const { jobs } = useJobContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jobDetails = jobName ? jobs[jobName] : undefined;

  if (!jobDetails) {
    return (
      <div className="text-center py-5">
        <h3>Job not found</h3>
      </div>
    );
  }

  return (
    <React.Fragment>
      <Navbars isDark={true} />
      <Section {...jobDetails} />
    </React.Fragment>
  );
};

export default DetailJob;
